// extracted by mini-css-extract-plugin
module.exports = {"container":"_1f3bcad8","title":"_e905f4df"};